import { Injectable, inject } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { of } from 'rxjs';
import * as contentblockActions from '../actions/content-pages.action';
import { switchMap, map, catchError } from 'rxjs/operators';
import { ContentPagesService } from '../../services';

@Injectable()
export class ContentPagesEffects {
  private actions$ = inject(Actions);
  private PageService = inject(ContentPagesService);


  LoadBugs$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(contentblockActions.LoadContentPages),
      switchMap(() => this.PageService.getPages()),
      map(contentPages => contentblockActions.LoadContentPagesSuccess({ contentPages })),
      catchError(error => of(contentblockActions.LoadContentPagesFail({ error })))
    );
  });

  LoadSubPages$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(contentblockActions.LoadSubContentPages),
      switchMap(({ id }) =>
        this.PageService.getSubPages(id).pipe(
          map(contentPages => contentblockActions.LoadSubContentPagesSuccess({ contentPages })),
          catchError(error => of(contentblockActions.LoadSubContentPagesFail({ error })))
        )
      )
    );
  });
}
